var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("ModalAjoutMvtStock", {
        ref: "modalAjoutMvtStock",
        attrs: {
          id: "modalAjoutMvtStock",
          disabled: _vm.inventaireOuvert,
          title: "Ajouter en stock",
          dateEtatAu: _vm.dateEtatAu,
          action: "in",
          mode: "stock",
          datesInvalides: _vm.datesInvalidesMvtStock
        },
        on: {
          "envoyer-article": function($event) {
            return _vm.enregistrerEnStock($event)
          }
        }
      }),
      _c("ModalAjoutMvtStock", {
        ref: "modalRetraitMvtStock",
        attrs: {
          id: "modalRetraitMvtStock",
          disabled: _vm.inventaireOuvert,
          title: "Retirer du stock",
          dateEtatAu: _vm.dateEtatAu,
          action: "out",
          mode: "stock",
          datesInvalides: _vm.datesInvalidesMvtStock
        },
        on: {
          "envoyer-article": function($event) {
            return _vm.retirerDuStock($event)
          }
        }
      }),
      _c(
        "div",
        { staticClass: "container-fluid" },
        [
          _c("BarreFiltres", {
            attrs: { filtres: _vm.filtres },
            on: {
              "appliquer-filtre": function($event) {
                return _vm.appliquerFiltre($event)
              }
            }
          }),
          _c("BarreActions", {
            attrs: { actions: _vm.actions },
            on: {
              "appliquer-action": function($event) {
                return _vm.executerAction($event)
              }
            }
          }),
          _c(
            "div",
            { staticClass: "card table-scroll height-responsive-100" },
            [
              _c(
                "div",
                { staticClass: "card-header flex-center-space-between" },
                [
                  _c("div", { staticClass: "flex-start" }, [
                    _c("span", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.formatHumanDate(new Date(_vm.stock.date))
                          ) +
                          " "
                      ),
                      _vm.stock &&
                      _vm.stock.date &&
                      _vm.formatDateAvecTirets(new Date(_vm.stock.date)) !==
                        _vm.formatDateAvecTirets(new Date())
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-warning btn-sm ml-2",
                              attrs: {
                                type: "button",
                                title: "Afficher aujourd'hui"
                              },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  _vm.changerDateStock(new Date())
                                }
                              }
                            },
                            [_vm._v(" Afficher stock d'aujourd'hui ")]
                          )
                        : _vm._e()
                    ]),
                    _vm.inventaireOuvert
                      ? _c("span", { staticClass: "text-warning ml-3" }, [
                          _c("i", {
                            staticClass:
                              "fas fa-exclamation-triangle text-warning"
                          }),
                          _vm._v(
                            " Inventaire en cours : toutes les modifications sont verrouillées"
                          )
                        ])
                      : _vm._e()
                  ]),
                  _c("div", { staticClass: "flex-end" }, [
                    _c("span", { staticClass: "ml-5" }, [
                      _vm._v(
                        "Total HT : " +
                          _vm._s(
                            _vm._f("afficherPrix2")(_vm.stock.valeurTotale)
                          )
                      )
                    ]),
                    _c("span", { staticClass: "ml-5" }, [
                      _vm._v(
                        "Total TTC : " +
                          _vm._s(
                            _vm._f("afficherPrix2")(_vm.stock.valeurTotaleTTC)
                          )
                      )
                    ])
                  ])
                ]
              ),
              _vm._m(0),
              _c("div", { staticClass: "table-body" }, [
                _vm.enCalculStock
                  ? _c("div", { staticStyle: { "text-align": "center" } }, [
                      _c("img", {
                        staticStyle: { height: "160px" },
                        attrs: {
                          alt: "en attente",
                          src: "/assets/images/spinners/cooking-blue-court.gif"
                        }
                      })
                    ])
                  : _c(
                      "table",
                      {
                        staticClass: "table table-sm table-bordered text-center"
                      },
                      [
                        _vm._m(1),
                        _c(
                          "tbody",
                          [
                            _vm._l(_vm.stock.zonesStockage, function(zone, i) {
                              return [
                                _c(
                                  "tr",
                                  {
                                    key: "zone" + i,
                                    staticClass: "table-header-tertiary",
                                    staticStyle: {
                                      position: "sticky",
                                      top: "0",
                                      "z-index": "5"
                                    }
                                  },
                                  [
                                    _c("td", { attrs: { colspan: "6" } }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex-center-space-between"
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                zone.designation.toUpperCase()
                                              )
                                            )
                                          ]),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("afficherPrix")(
                                                  zone.valeur
                                                )
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    ])
                                  ]
                                ),
                                _vm._l(
                                  zone.ingredients.filter(function(i) {
                                    return (
                                      _vm.afficherQuantitesAZero ||
                                      (i.lots &&
                                        i.lots.reduce(function(q, l) {
                                          return q + l.quantite
                                        }, 0) !== 0)
                                    )
                                  }),
                                  function(ingredient, index) {
                                    return [
                                      _c(
                                        "tr",
                                        {
                                          key: "zone" + i + "ing" + index,
                                          staticClass: "table-header-secondary"
                                        },
                                        [
                                          _c(
                                            "td",
                                            { attrs: { colspan: "6" } },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "container-fluid"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "row" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-8 flex-start"
                                                        },
                                                        [
                                                          ingredient.id != 0
                                                            ? _c(
                                                                "BtnAffichageMvtsStock",
                                                                {
                                                                  staticClass:
                                                                    "mr-1",
                                                                  attrs: {
                                                                    id:
                                                                      zone.designation +
                                                                      "_" +
                                                                      ingredient.id,
                                                                    ingredient: ingredient,
                                                                    debut:
                                                                      _vm
                                                                        .filtres
                                                                        .dateStock
                                                                        .selection,
                                                                    avecDetails: true
                                                                  }
                                                                }
                                                              )
                                                            : _c("i", {
                                                                staticClass:
                                                                  "fas fa-exclamation-triangle error mr-2"
                                                              }),
                                                          ingredient.id == 0
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "error"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      ingredient.nom.toUpperCase()
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            : _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    ingredient.nom.toUpperCase()
                                                                  )
                                                                )
                                                              ])
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-2 flex-end"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "afficherArrondi"
                                                                )(
                                                                  ingredient.quantite
                                                                )
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                ingredient.uc
                                                              ) +
                                                              " "
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-2 flex-end"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "afficherPrix"
                                                                )(
                                                                  ingredient.valeur
                                                                )
                                                              ) +
                                                              " "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._l(
                                        ingredient.lots.filter(function(l) {
                                          return (
                                            _vm.afficherQuantitesAZero ||
                                            l.quantite !== 0
                                          )
                                        }),
                                        function(lot, indexLot) {
                                          return _c(
                                            "tr",
                                            {
                                              key:
                                                "zone" +
                                                i +
                                                "ing" +
                                                index +
                                                "lot" +
                                                indexLot
                                            },
                                            [
                                              _c(
                                                "td",
                                                {
                                                  staticStyle: {
                                                    "vertical-align": "middle"
                                                  },
                                                  style:
                                                    lot.quantite == 0
                                                      ? "color: lightgrey;font-style:italic"
                                                      : ""
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(lot.reference) +
                                                      " "
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "aligner-gauche"
                                                },
                                                [
                                                  _c("BtnAffichageMvtsStock", {
                                                    staticClass: "mr-1",
                                                    attrs: {
                                                      id: lot.id,
                                                      lot: lot,
                                                      debut:
                                                        _vm.filtres.dateStock
                                                          .selection,
                                                      avecDetails: true
                                                    }
                                                  }),
                                                  _c(
                                                    "span",
                                                    {
                                                      style:
                                                        lot.quantite == 0
                                                          ? "color: lightgrey;font-style:italic"
                                                          : ""
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          lot.designationFournisseur
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "td",
                                                {
                                                  staticStyle: {
                                                    "vertical-align": "middle"
                                                  },
                                                  style:
                                                    lot.quantite == 0
                                                      ? "color: lightgrey;font-style:italic"
                                                      : ""
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(lot.NumLot) +
                                                      " "
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "td",
                                                {
                                                  staticStyle: {
                                                    "vertical-align": "middle"
                                                  },
                                                  style:
                                                    lot.quantite == 0
                                                      ? "color: lightgrey;font-style:italic"
                                                      : ""
                                                },
                                                [
                                                  _vm.dluoProcheOuDepassee(
                                                    lot
                                                  ) ||
                                                  _vm.dlcProche(lot) ||
                                                  _vm.dlcDepassee(lot)
                                                    ? _c("i", {
                                                        directives: [
                                                          {
                                                            name: "tooltip",
                                                            rawName:
                                                              "v-tooltip",
                                                            value: {
                                                              content:
                                                                (_vm.dluoProcheOuDepassee(
                                                                  lot
                                                                )
                                                                  ? "DDM proche ou dépassée : "
                                                                  : _vm.dlcProche(
                                                                      lot
                                                                    )
                                                                  ? "DLC proche : "
                                                                  : _vm.dlcDepassee(
                                                                      lot
                                                                    )
                                                                  ? "DLC dépassée : "
                                                                  : "") +
                                                                _vm.formatHumanDate(
                                                                  lot.dlcDluo
                                                                ),
                                                              placement:
                                                                "bottom"
                                                            },
                                                            expression:
                                                              "{ content: (dluoProcheOuDepassee(lot) ? 'DDM proche ou dépassée : ' : dlcProche(lot) ? 'DLC proche : ' : dlcDepassee(lot) ? 'DLC dépassée : ' : '') + formatHumanDate(lot.dlcDluo), placement: 'bottom' }"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "fas fa-exclamation-triangle",
                                                        style: _vm.dlcDepassee(
                                                          lot
                                                        )
                                                          ? "color:red"
                                                          : "color:orange"
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.formatHumanDate(
                                                          lot.dlcDluo
                                                        )
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              ),
                                              _c("td", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex-center-space-between"
                                                  },
                                                  [
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn btn-primary btn-sm",
                                                        attrs: {
                                                          type: "button",
                                                          disabled:
                                                            _vm.inventaireOuvert,
                                                          title:
                                                            "Retirer une quantité"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.afficherRetraitMvtStock(
                                                              lot
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-minus"
                                                        })
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        style:
                                                          lot.quantite == 0
                                                            ? "color: lightgrey;font-style:italic"
                                                            : ""
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "afficherArrondi"
                                                            )(lot.quantite)
                                                          ) +
                                                            " " +
                                                            _vm._s(lot.uc)
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn btn-primary btn-sm",
                                                        attrs: {
                                                          type: "button",
                                                          disabled:
                                                            _vm.inventaireOuvert,
                                                          title:
                                                            "Ajouter une quantité"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.afficherAjoutMvtStock(
                                                              lot
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-plus"
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]),
                                              _c(
                                                "td",
                                                {
                                                  staticStyle: {
                                                    "vertical-align": "middle",
                                                    "text-align": "right"
                                                  },
                                                  style:
                                                    lot.quantite == 0
                                                      ? "color: lightgrey;font-style:italic"
                                                      : ""
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f("afficherPrix")(
                                                          lot.quantite *
                                                            (lot.valeurUnitaire
                                                              ? lot.valeurUnitaire
                                                              : 0)
                                                        )
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        }
                                      )
                                    ]
                                  }
                                )
                              ]
                            })
                          ],
                          2
                        )
                      ]
                    )
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "table",
      {
        staticClass:
          "table table-bordered table-sm text-center table-header-secondary"
      },
      [
        _c("colgroup", [
          _c("col", { attrs: { width: "120" } }),
          _c("col"),
          _c("col", { attrs: { width: "120" } }),
          _c("col", { attrs: { width: "120" } }),
          _c("col", { attrs: { width: "150" } }),
          _c("col", { attrs: { width: "120" } })
        ]),
        _c("thead", [
          _c("th", [_vm._v("Référence")]),
          _c("th", { staticClass: "aligner-gauche" }, [_vm._v("Désignation")]),
          _c("th", [_vm._v("N° Lot")]),
          _c("th", [_vm._v("DLC/DDM")]),
          _c("th", [_vm._v("Quantité")]),
          _c("th", [_vm._v("Total HT")])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "120" } }),
      _c("col"),
      _c("col", { attrs: { width: "120" } }),
      _c("col", { attrs: { width: "120" } }),
      _c("col", { attrs: { width: "150" } }),
      _c("col", { attrs: { width: "115" } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }